import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import WhatYouWillLearn from './whatyouwilllearn';
import DemoVideo from './DemoVideo';
import CourseContentSection from './CourseContentSection';
import BonusSection from './BonusSection';
import FAQSection from './FAQSection';
import FooterSection from './FooterSection';
import MobileStickyBar from './MobileStickyBar';


// Create root element for rendering
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app with all components
root.render(
  <React.StrictMode>
    <div style={{ paddingBottom: 'env(safe-area-inset-bottom, 140px)' }}>
      <App />
      <WhatYouWillLearn />
      <DemoVideo />
      <BonusSection />
      {/* Assign an ID to CourseContentSection for scrolling */}
      <CourseContentSection id="course-content" />
      <FAQSection />
      <FooterSection />
      <MobileStickyBar />

    </div>
  </React.StrictMode>
);
